module.exports = __webpack_public_path__ + "static/media/corporate-services-img68.165f1c71.jpg";